export default [
  {
    path: '/user/profile',
    name: 'user.profile',
    component: () => import('@/views/pages/user/Profile.vue')
  }
]